const AddressBook = () => import('@/views/AddressBook')

export default [
  {
    path: '/addressBook',
    component: AddressBook,
    meta: { requireAuth: true }
  }
]
